import EmberService, { service } from '@ember/service';

import type { EntryPointElement, Root } from '@databox/ember-integrations/lib/components/Setup';
import { create, render, unmount } from '@databox/ember-integrations/lib/components/Setup';

import type { Service } from 'webapp-types';

export default class ReactService extends EmberService {
	@service('navigation') declare navigationService: Service.Navigation;

	create(node: HTMLDivElement): Root {
		return create(node);
	}

	render(root: Root, children: EntryPointElement, mode?: 'open' | 'closed'): void {
		render(root, children, this.navigationService.theme.isDark, mode);
	}
	unmount(root: Root | null): void {
		if (root) {
			unmount(root);
			root = null;
		}
	}
}

declare module '@ember/service' {
	interface Registry {
		react: ReactService;
	}
}
